import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VueAnalytics from 'vue-analytics'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'simplebar'
import 'simplebar/dist/simplebar.css'
import * as DB from './database'

global.DEBUG = process.env.NODE_ENV !== 'production'

Vue.use(Vuetify, {
  theme: {
    primary: '#6b4fbb',
    // secondary: '#000000'
    accent: '#fc6d26'
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-2807532-24',
  router,
  autoTracking: {
    exception: true,
    exceptionLogs: global.DEBUG
  },
  batch: {
    enabled: true,
    amount: 10,
    delay: 2000 // milliseconds
  },
  debug: {
    enabled: global.DEBUG
  }
})

Vue.config.productionTip = false

if (!String.format) {
  String.format = function (format) {
    let args = Array.prototype.slice.call(arguments, 1)
    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match
    })
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    if (window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches) { store.commit('setIsStandalone', { isStandalone: true }) }

    if (store.state.isStandalone) {
      router.replace({ path: 'chat' })
    }

    firebase.initializeApp({
      apiKey: 'AIzaSyAWVQZYgVbAvWA1-IZu0jRRSl5nrXT1tzI',
      authDomain: 'random-video-chat-34e27.firebaseapp.com',
      databaseURL: 'https://random-video-chat-34e27.firebaseio.com',
      projectId: 'random-video-chat-34e27',
      storageBucket: 'random-video-chat-34e27.appspot.com',
      messagingSenderId: '62391710558'
    })

    if (global.DEBUG) {
      console.log('DB.SESSIONS: ' + DB.SESSIONS)
      console.log('DB.SESSION: ' + String.format(DB.SESSION, 'userId1'))

      console.log('DB.WAITING_USERS: ' + DB.WAITING_USERS)
      console.log('DB.WAITING_USER: ' + String.format(DB.WAITING_USER, 'userId1'))

      console.log('DB.INVITATIONS: ' + String.format(DB.INVITATIONS, 'userId1'))
      console.log('DB.INVITATION: ' + String.format(DB.INVITATION, 'userId1', 'invitation1'))

      console.log('DB.ROOMS: ' + DB.ROOMS)
      console.log('DB.ROOM: ' + String.format(DB.ROOM, 'roomId1'))
      console.log('DB.ROOM_USERS: ' + String.format(DB.ROOM_USERS, 'roomId1'))
      console.log('DB.ROOM_USER: ' + String.format(DB.ROOM_USER, 'roomId1', 'userId1'))

      console.log('DB.CHAT_ROOM: ' + String.format(DB.CHAT_ROOM, 'roomId1'))
      console.log('DB.CHAT_ROOM_MESSAGE: ' + String.format(DB.CHAT_ROOM_MESSAGE, 'roomId1', 'msgId1'))

      console.log('DB.WEBRTC_ROOM: ' + String.format(DB.WEBRTC_ROOM, 'roomId1'))
      console.log('DB.WEBRTC_ROOM_USER: ' + String.format(DB.WEBRTC_ROOM_USER, 'roomId1', 'userId1'))
      console.log('DB.WEBRTC_ROOM_USER_MESSAGE: ' + String.format(DB.WEBRTC_ROOM_USER_MESSAGE, 'roomId1', 'userId1', 'msgId1'))
    }

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        if (!user.isAnonymous) {
          this.$ga.set({ userId: user.uid })
        }
        let connectedUsersRef = firebase.database().ref(String.format(DB.SESSION, user.uid))
        connectedUsersRef.onDisconnect().remove()
        connectedUsersRef.set(firebase.database.ServerValue.TIMESTAMP).then(() => {
          global.DEBUG && console.log('signed int')
          store.commit('setUserId', { userId: user.uid })
          store.commit('setSignedIn', { signedIn: true })
          firebase.database().ref(String.format(DB.INVITATIONS, user.uid)).on('child_added', snapshot => {
            let invitation = snapshot.val()
            if (invitation !== null) {
              store.dispatch('handleInvitation', invitation)
            }
          })
          firebase.database().ref('Stats/SessionCount/current').on('value', snapshot => {
            store.commit('setOnlineUserCount', { onlineUserCount: snapshot.val() + 810 })
          })
        })
      } else if (store.state.userId !== null) {
        global.DEBUG && console.log('logged out')
        firebase.database().ref(String.format(DB.SESSION, store.state.userId)).set(null)
        store.commit('setSignedIn', { signedIn: false })
        store.commit('setUserId', { userId: null })
      }
    })

    // Automatically signup anonymously
    store.dispatch('signUp')
  }
})



// WEBPACK FOOTER //
// ./src/main.js